import type { DataSource } from '../../types/health';
import './DataSourceLabel.css';

const sourceLabels: Record<DataSource, string> = {
  apple_health: 'Apple Health',
  manual: 'Manual',
  calculated: 'Calculated',
};

export function DataSourceLabel({ source, estimated = false }: { source: DataSource; estimated?: boolean }) {
  return (
    <span className="source-label" data-estimated={estimated}>
      {estimated ? 'Estimated' : `Recorded from ${sourceLabels[source]}`}
    </span>
  );
}
